import { formComponents as fc } from '@/components/form';
import useOrganisationOptions from '@/components/hooks/useOrganisationOptions';

const SelectFromMyOrganisationIds = ({ name }: { name?: string }) => {
	const { organisationIdOptions } = useOrganisationOptions();
	return <fc.Select name={name ?? 'organisation_id'} label="Organisation" options={organisationIdOptions} />;
};

export default SelectFromMyOrganisationIds;
